import $ from 'jquery/src/jquery';
import 'jquery-ui/ui/widgets/accordion';
import 'isotope-layout/dist/isotope.pkgd';
import 'select2';
import 'select2/dist/css/select2.min.css';

$(document).ready(function($) {

    $('.jobsListing').each(function (index, element) {
        const $this = $(element);
        const $filterDropdown = $this.find('select');
        const $grid = $('[class*="__items"]');
        const $items = $grid.find('.jobsListing__item');
        const $nothingFound = $this.find('.jobsListing__nothingFound');
        $filterDropdown.
            select2({
                minimumResultsForSearch: Infinity,
                width: '100%'
            })
            .on('change', function () {
                const filterValue = $(this).val() ? $(this).val() : '*';
                $items.each(function (index, item) {
                    $(item).toggle( filterValue === '*' || $(item).hasClass( filterValue ) );
                });
                $nothingFound.toggle( $items.filter(':visible').length === 0 );
            })
            .trigger('change');
    });
});